module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-158.73272eb2.jpg";